import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);

const SELECTOR_COUNTER = '.js-counter';

function parseNumber(attr, fallback) {
  const v = parseFloat(attr);
  return Number.isFinite(v) ? v : fallback;
}

export function initHiTechCounters() {
  const reduce = window.matchMedia?.('(prefers-reduced-motion: reduce)')?.matches;
  const counters = gsap.utils.toArray(SELECTOR_COUNTER);

  if (!counters.length) return;

  if (reduce) {
    // Accessibilité : pas d’anim, valeur directe
    counters.forEach((el) => {
      el.style.opacity = 1;
      el.style.transform = 'none';
    });
    return;
  }

  counters.forEach((el) => {
    const endAttr = el.getAttribute('data-counter-target');
    const end     = parseFloat(endAttr || el.textContent.replace(/\s/g, ''));

    if (!Number.isFinite(end)) return;

    const duration = parseNumber(el.getAttribute('data-counter-duration'), 1.4);
    const obj      = { value: 0 };

    ScrollTrigger.create({
      trigger: el,
      start: 'top 85%',
      once: true,
      onEnter: () => {
        gsap.to(obj, {
          value: end,
          duration,
          ease: 'power2.out',
          onUpdate: () => {
            el.textContent = Math.round(obj.value).toLocaleString('fr-FR');
          }
        });
      }
    });
  });
}
